// Liczby wpisywane przez polskich użytkowników: przecinek dziesiętny i spacje tysięcy ("1 200,50").
// Pole jest type="text" (type="number" gubi przecinek), więc normalizacja i walidacja są po stronie JS.

const INTEGER = /^[+-]?\d+$/
const DECIMAL = /^[+-]?\d+(\.\d+)?$/

// Usuwa spacje (także NBSP i wąskie spacje) i zamienia przecinek na kropkę.
export function normaliseNumberText(raw) {
  return String(raw).replace(/[\s  ]/g, "").replace(",", ".")
}

// → { ok, value }: integer daje Number, pozostałe typy napis typu "1200.50".
export function parseNumber(raw, type) {
  const text = normaliseNumberText(raw)
  if (type === "integer") {
    return INTEGER.test(text) ? { ok: true, value: Number(text) } : { ok: false, value: raw }
  }
  return DECIMAL.test(text) ? { ok: true, value: text } : { ok: false, value: raw }
}

// "0.00" → "0", "0.50" → "0,5": podpowiedź zakresu w polskim zapisie.
export function formatBound(bound) {
  const number = Number(bound)
  return Number.isFinite(number) ? String(number).replace(".", ",") : String(bound)
}
